<template>
    <div id="Download">
        <Nav />
        <Banner :url="bannerurl" :showDownload="true"/>
        <Contact />
    </div>
</template>

<script>
    import Nav from '@/components/common/nav'
    import Banner from '@/components/common/banner'
    import Contact from '@/components/common/contact'
    export default {
        name: "Download",
        data(){
            return{
                bannerurl:'../../../static/images/download_banner.png',
            }
        },
        methods:{
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop <= 0) {
                    document.getElementsByClassName('navbar-inverse')[0].removeAttribute('style')
                } else {
                    document.getElementsByClassName('navbar-inverse')[0].setAttribute('style','background:#262626;height:80px;')
                }
            }
        },
        components: {
            Nav,
            Banner,
            Contact
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Download.vue